
  const coa = {
    path: "/process-summary",
    name: "processSummary",
    component: () => import(/* webpackChunkName: "processSummary" */ "@/components/process/processSummary.vue"),
    meta: { authorize: ['Administrator', 'Manager', 'Factory', 'Factory - Process Report'], requiresAuth: true }
  };

export default coa;